import { z } from 'zod'

const confSchema = z.object({
  ENV: z.enum(['staging', 'production', 'development', 'local', 'ci']).default('ci'),
  STORYBOOK: z.boolean().default(false),
  TOKEN_KEY: z.string().default('mwtoken'),
  /**
   * The key prefix of the host's token set, the PWA's LOCALSTORAGE_AUTHTOKEN_KEY. Not TOKEN_KEY,
   * which deployed builds set to the PWA's full access-token key: as a prefix it names no key.
   */
  HOST_TOKEN_PREFIX: z
    .string()
    .min(1)
    .refine((prefix) => !prefix.includes(':'), 'a key prefix, not a full key: it has no ":"')
    .default('mwtoken'),

  INVOICING_MICRO_FRONTEND_URL: z.string().default(''),

  // single api should be provided or both urls should be provided therefore they all optional
  API_URL: z.string().default(''),
  INVOICING_API_URL: z.string().default(''),
  FOREMAN_API_URL: z.string().default(''),
  WHEELBARROW_API_URL: z.string().default(''),
  AUTH_API_URL: z.string().default(''),

  SENTRY_DSN: z.string().default(''),
  SEGMENT_WRITE_KEY: z.string().default(''),
  PUBLIC_POSTHOG_HOST: z.string().default('https://eu.i.posthog.com'),
  PUBLIC_POSTHOG_KEY: z.string().default('phc_jjEdt4E4BuIvJqbKKWp7o4gVVBgt9ZAVOlpOm74ss4h'),

  USER_ID: z.string().default(''), // apparently for local foreman user and company ids equal to 2
  COMPANY_ID: z.string().default(''),
  USER_EMAIL: z.string().default('yurii@meisterwerk.app'),
  USER_PASSWORD: z.string().default('test'),
})

/** The config from the environment a build was made with; throws on a value the schema refuses */
export const parseConf = (env: Record<string, unknown>) =>
  confSchema.parse({
    ENV: env.VITE_ENV,
    STORYBOOK: env.VITE_STORYBOOK === 'true',
    TOKEN_KEY: env.VITE_TOKEN_KEY,
    HOST_TOKEN_PREFIX: env.VITE_HOST_TOKEN_PREFIX,

    INVOICING_MICRO_FRONTEND_URL: env.VITE_INVOICING_MICRO_FRONTEND_URL,

    API_URL: env.VITE_BACKEND_API_URL,
    INVOICING_API_URL: env.VITE_INVOICING_API_URL,
    FOREMAN_API_URL: env.VITE_FOREMAN_API_URL,
    WHEELBARROW_API_URL: env.VITE_WHEELBARROW_API_URL,
    AUTH_API_URL: env.VITE_AUTH_API_URL,

    SENTRY_DSN: env.VITE_SENTRY_DSN,
    SEGMENT_WRITE_KEY: env.VITE_SEGMENT_WRITE_KEY,
    PUBLIC_POSTHOG_HOST: env.VITE_PUBLIC_POSTHOG_HOST,
    PUBLIC_POSTHOG_KEY: env.VITE_PUBLIC_POSTHOG_KEY,

    USER_ID: env.VITE_USER_ID,
    COMPANY_ID: env.VITE_COMPANY_ID,
  })

export const conf = parseConf(import.meta.env)

if (conf.ENV !== 'ci') {
  if (conf.API_URL === '' && conf.INVOICING_API_URL === '') {
    throw new Error(
      'API_URL, INVOICING_API_URL, or FOREMAN_API_URL is required for non-ci environments',
    )
  }
}
